import { commonActionTypes } from "../../ActionTypes/commonActionTypes";
import { customerActionTypes } from "../../ActionTypes/customerActionTypes";
import forms from "../../Constants/forms";
import * as formValidationRules from '../../Constants/formValidationRules';
import { productId } from "../../Constants/producs";
import { VonAccessRights, VonAccessRightsRoles } from "../../Constants/VON/EmployeeForm/vonAccessRights";
import { httpFetch } from "../../Utils/httpUtils";
import commonActions from "../commonActions";
import formActions from "../formActions";

const employeesActions = {
    checkVonEmployee(form) {
        return dispatch => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "checkVonUser", value: true });
            return httpFetch(`/api/customer/vonuser/${form.data.email}`, dispatch)
                .then(json => {
                    if (json.email) {
                        dispatch(formActions.startFormEditing(forms.vonNewEmployeeForm, { email: json.email, firstName: json.firstname, lastName: json.surname, type: "", userAlreadyExists: true }, formValidationRules.VonNewEmployeeForm));
                    } else {
                        dispatch(formActions.startFormEditing(forms.vonNewEmployeeForm, { email: form.data.email, type: "" }, formValidationRules.VonNewEmployeeForm));
                    }
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "checkVonUser", value: false });
                });
        }
    },

    addVonEmployee(newVonEmployeeForm, customerId, callback) {
        return dispatch => {

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({ ...newVonEmployeeForm.data, customerId })
            }

            return httpFetch('/api/employees/addVonEmployee', dispatch, httpRequest)
                .then(json => {
                    dispatch(commonActions.showSuccess('Employee saved successfully'));
                    callback();
                })
        }
    },

    inactivateVonEmployee(employeeId, callback) {
        return dispatch => {

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({})
            }

            return httpFetch(`/api/employees/inactivateVonEmployee/${employeeId}`, dispatch, httpRequest)
                .then(json => {
                    dispatch(commonActions.showSuccess('Employee inactivated successfully'));
                    callback();
                });
        };
    },

    deleteVonEmployee(employeeId, callback) {
        return dispatch => {

            const httpRequest = {
                method: 'DELETE'
            }

            return httpFetch(`/api/employees/deleteVonEmployee/${employeeId}`, dispatch, httpRequest)
                .then(json => {
                    dispatch(commonActions.showSuccess('Employee set to be deleted'));
                    callback();
                });
        };
    },


    updateVonEmployee(editVonEmployeeForm, editVonEmployeeRolesForm, editVonEmployeeEmailForm, customerId, callback) {
        return dispatch => {

            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify({
                    customerId,
                    details: editVonEmployeeForm.changed ? editVonEmployeeForm.data : null,
                    services: editVonEmployeeRolesForm.changed ? editVonEmployeeRolesForm.data : null,
                    email: editVonEmployeeEmailForm.changed ? editVonEmployeeEmailForm.data : null,
                }),
            };

            return httpFetch('/api/employees/updateVonEmployee', dispatch, httpRequest)
                .then(() => {
                    const messages = [];

                    if (editVonEmployeeForm.changed) {
                        messages.push('Employee details updated successfully.');
                    }
                    if (editVonEmployeeRolesForm.changed) {
                        messages.push('Employee roles updated successfully.');
                    }
                    if (editVonEmployeeEmailForm.changed) {
                        messages.push('An email has been sent to the new email address. It contains a link that the user must click on to verify the change.');
                    }

                    if (messages.length > 0) {
                        dispatch(commonActions.showSuccess(messages.join('\n')));
                    }
                    callback();
                })
        };
    },

    getEmployeeTypeRestrictions() {
        return dispatch => {
            return httpFetch('/api/employees/getVonEmployeeTypeRestrictions', dispatch)
                .then(json => {
                    dispatch({ type: customerActionTypes.STORE_VON_EMPLOYEE_TYPE_RESTRICTIONS, data: json });
                });
        };
    },

    getVonEmployeeForEdit(vonProducts, vonAccount) {
        return dispatch => {

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "vonEmployeeForEdit", value: true });

            dispatch(commonActions.startFormEditing('editVonEmployeeForm',
                {
                    email: vonAccount.email,
                    name: vonAccount.name,
                    isPrimaryContact: vonAccount.isPrimaryContact,
                    employeeId: vonAccount.id,
                    employeeTypeId: vonAccount.employeeType,
                    consultantId: vonAccount.consultantId,
                    onlineRoleId: vonAccount.roles.some(role => role.service === productId.vismaonline)
                        ? VonAccessRightsRoles[vonAccount.roles.find(role => role.service === productId.vismaonline).serviceRole]
                        : vonAccount.softDelete ? VonAccessRights.Delete : VonAccessRights.Inactive
                }));

            dispatch(commonActions.startFormEditing('editVonEmployeeEmailForm', {
                oldEmail: vonAccount.email,
                newEmail: null
            }))

            const services = vonProducts
                .filter(product => product.vonServiceRoles?.some(serviceRole =>
                    vonAccount.roles.some(role => role.applicationId === serviceRole.applicationId)
                ))
                .map(product => ({
                    serviceId: product.productNumber,
                    roleId: product.vonServiceRoles.find(serviceRole =>
                        vonAccount.roles.some(role => role.serviceRole === serviceRole.name)
                    ).id
                }));

            dispatch(commonActions.startFormEditing('editVonEmployeeRolesForm', {
                services: services,
                employeeId: vonAccount.id
            }));

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "vonEmployeeForEdit", value: false });
        }
    },

    beginVonLicenseAdministrationForm(vonAccounts, service) {
        return dispatch => {

            const employees = vonAccounts
                .filter(account => service.vonServiceRoles.some(serviceRole =>
                    account.roles.some(role => role.applicationId === serviceRole.applicationId)
                ))
                .map(account => ({
                    employeeId: account.id,
                    roleId: service.vonServiceRoles.find(serviceRole =>
                        account.roles.some(role => role.serviceRole === serviceRole.name)
                    ).id
                }));

            const data = {
                serviceId: service.productNumber,
                employees: employees
            };

            dispatch(commonActions.startFormEditing('vonLicenseAdministrationForm', data));
        };
    },

    bulkUpdateVonEmployeeServices(form, callback) {
        return dispatch => {

            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify(form.data)
            };

            return httpFetch(`/api/employees/bulkUpdateVonEmployeeRolesForServices/`, dispatch, httpRequest)
                .then(json => {
                    dispatch(commonActions.showSuccess('Licenses updated successfully'));
                    callback();
                });
        };
    },
}

export default employeesActions;